import storage from './cacheUtils';

/**
 * 版本号存储的key
 */
const VERSION_KEY = 'APP_VERSION';

/**
 * 获取项目当前版本号
 * @returns 当前版本号
 */
export const getCurrentVersion = (): string => {
  // 在生产环境中，我们会从package.json中读取版本号
  // 但在实际运行时，我们可以从环境变量或全局配置中获取
  try {
    // 这里假设版本号已经通过构建过程注入到全局变量中
    // 或者从meta标签中读取
    if (window.__APP_VERSION__) {
      return window.__APP_VERSION__;
    }
    
    // 作为备选方案，尝试从环境变量中获取
    if (import.meta.env.VITE_APP_VERSION) {
      return import.meta.env.VITE_APP_VERSION;
    }
  } catch (error) {
    console.warn('获取版本号失败:', error);
  }
  
  // 如果都获取不到，返回一个默认版本号
  return '0.0.0';
};

/**
 * 检查版本是否更新，并在需要时清空缓存
 * @returns 是否进行了版本更新
 */
export const checkVersionUpdate = (): boolean => {
  const currentVersion = getCurrentVersion();
  const storedVersion = storage.get(VERSION_KEY);
  
  // 如果是首次运行或版本号不一致，清空缓存并更新版本号
  if (!storedVersion || storedVersion !== currentVersion) {
    // 清空所有带有应用前缀的缓存
    storage.clearSelf();
    
    // 同时清空 store 相关的缓存（使用 app_store_ 前缀）
    const storePrefix = 'app_store_';
    const authKey = 'app_auth';
    
    // 遍历 localStorage，删除所有 store 相关的缓存
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (key.startsWith(storePrefix) || key === authKey)) {
        keysToRemove.push(key);
      }
    }
    
    keysToRemove.forEach(key => localStorage.removeItem(key));
    
    // 保存当前版本号
    storage.set(VERSION_KEY, currentVersion);
    
    console.log(`版本从 ${storedVersion || '首次启动'} 更新到 ${currentVersion}，已清空所有缓存`);
    return true;
  }
  
  return false;
};

/**
 * 初始化版本检查
 * 在应用启动时调用
 */
export const initVersionCheck = (): void => {
  try {
    const hasUpdated = checkVersionUpdate();
    if (hasUpdated) {
      // 可以在这里添加版本更新后的处理逻辑
      // 例如显示更新提示、记录更新日志等
    }
  } catch (error) {
    console.error('版本检查失败:', error);
  }
};

export default {
  getCurrentVersion,
  checkVersionUpdate,
  initVersionCheck
};